import {MiniSignal, texture} from "p3";
import common from "../common";
import Scene from "./Scene";

export default class CNPreloaderScene extends Scene {
    constructor() {
        super("preloader");

        this.progress = 0;

        this._loader = null;
        this._loaderTween = null;

        this._fillScrollSpeed = 160;
        this._fillMaskWidth = 0;
        this._fillMaskSmoothing = 16;

        this._finishedLoading = false;

        this.signals.loaded = new MiniSignal();
    }

    init() {
        this._loader = new PIXI.Container();
        this._loader.position.set(common.STAGE_WIDTH * 0.5, 420);
        this.addChild(this._loader);

        this._loader.logo = new PIXI.Sprite(texture("cn_preloader_logo"));
        this._loader.logo.position.set(0, -100);
        this._loader.logo.anchor.set(0.5);
        this._loader.logo.visible = false;
        this._loader.addChild(this._loader.logo);

        this._loader.bar = new PIXI.Container();
        this._loader.bar.position.set(0, 54);
        this._loader.bar.visible = false;
        this._loader.addChild(this._loader.bar);

        const tex = texture("cn_preloader_fill");
        this._loader.bar.fill = new PIXI.TilingSprite(tex, tex.width, tex.height);
        this._loader.bar.fill.anchor.set(0.5);
        this._loader.bar.addChild(this._loader.bar.fill);

        this._loader.bar.fill.mask = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._loader.bar.fill.mask.anchor.set(0, 0.5);
        this._loader.bar.fill.mask.width = this._fillMaskWidth = 362;
        this._loader.bar.fill.mask.height = 60;
        this._loader.bar.fill.mask.x = -this._loader.bar.fill.mask.width * 0.5;
        this._loader.bar.fill.mask.scale.x = 0;
        this._loader.bar.fill.mask.tint = 0xFF0000;
        this._loader.bar.fill.addChild(this._loader.bar.fill.mask);

        this._loader.bar.frame = new PIXI.Sprite(texture("cn_preloader_capsule"));
        this._loader.bar.frame.anchor.set(0.5);
        this._loader.bar.addChild(this._loader.bar.frame);

        this._warmupFont = new PIXI.Text("", { fontFamily: "FredFredBurger" });
        this.addChild(this._warmupFont);
    }

    destroy() {
        this.stopAnimation();
    }

    resize() {
        super.resize();
    }

    update() {
        this.cleanupTweens();

        let progress = Math.min(1, this.progress);
        if (progress >= 0.99 && !this._finishedLoading) {
            this._finishedLoading = true;

            this.animateOut().then(() => this.signals.loaded.dispatch());
        }

        this._loader.bar.fill.mask.width += ((progress * this._fillMaskWidth) - this._loader.bar.fill.mask.width)
            * this._fillMaskSmoothing * window.dt;

        this._loader.bar.fill.tilePosition.x += this._fillScrollSpeed * window.dt;
    }

    /**
     * @returns {Promise}
     */
    animateIn() {
        return new Promise((resolve) => {
            this.stopAnimation();

            this._loaderTween = gsap.timeline({ onComplete: resolve });
            this.addTween(this._loaderTween);

            this._loader.logo.scale.set(0);
            this._loaderTween.add(gsap.to(this._loader.logo.scale, 0.24, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                onStart: () => this._loader.logo.visible = true
            }), 0);

            this._loader.bar.scale.set(0);
            this._loaderTween.add(gsap.to(this._loader.bar.scale, 0.24, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                onStart: () => this._loader.bar.visible = true
            }), 0.06);
        });
    }

    /**
     * @returns {Promise}
     */
    animateOut() {
        return new Promise((resolve) => {
            this.stopAnimation();

            this._loaderTween = gsap.timeline({ onComplete: resolve });
            this.addTween(this._loaderTween);

            this._loaderTween.add(gsap.to(this._loader, 0.22, {
                delay: 0.5,
                alpha: 0,
                ease: Power1.easeInOut
            }));
            this._loaderTween.add(gsap.delayedCall(0.2, () => {}));
        });
    }

    stopAnimation() {
        if (this._loaderTween) {
            this._loaderTween.kill();
            this._loaderTween = null;
        }
    }
}